import { ChangeDetectorRef, Component, OnInit } from "@angular/core";

import { LayoutService } from "../../services/layout.service";
import { IconConst } from "../../../../shared/constants/icon.constant";
import { environment } from "@env/environment.prod";
import { LoginService } from "@app/modules/auth/login/services/login.service";
import { LocalStorageService } from "@app/shared/services/local-storage/local-storage.service";
import { GlobalService } from "@app/shared/services/global/global.service";
import { Subscription } from "rxjs";
import { NavigationStateService } from "@app/modules/organization/services/dashboardClick.service";
import { Router } from "@angular/router";

@Component({
  selector: "crm-side-nav",
  templateUrl: "./side-nav.component.html",
  styleUrls: ["./side-nav.component.scss"],
})
export class SideNavComponent implements OnInit {
  defaultImagePath = environment.defaultImagePath;
  imageUrl = environment.defaultImageUrl;
  iconConst = IconConst;
  navItems: any;
  user_type_id: any = 0;
  private navSubscription: Subscription; // To prevent memory leaks

  // navItems = [
  //   {
  //     id: 1,
  //     displayName: "Dashboard",
  //     iconName: this.iconConst.DASHBOARD,
  //     route: "/dashboard",
  //   },
  //   {
  //     id: 3,
  //     displayName: "Admin Dashboard",
  //     iconName: this.iconConst.DASHBOARD,
  //     route: "/dashboard2",
  //   },
  //   // {
  //   //   id: 2,
  //   //   displayName: "Company",
  //   //   iconName: "fa fa-building",
  //   //   route: "company",
  //   // },
  //   // {
  //   //   id: 3,
  //   //   displayName: "Leads",
  //   //   iconName: "fa fa-bullhorn",
  //   //   route: "leads",
  //   // },
  //   // {
  //   //   id: 4,
  //   //   displayName: "Lead Contacts",
  //   //   iconName: this.iconConst.CONTACT,
  //   //   route: "lead-contacts",
  //   // },
  //   /*   {
  //        id: 5,
  //        displayName: "Bid Information",
  //        iconName: this.iconConst.BID_INFORMATION,
  //        route: "bid-information",
  //      },
  //      {
  //        id: 6,
  //        displayName: "Groups",
  //        iconName: this.iconConst.GROUPS,
  //        route: "groups",
  //      },

  //   {
  //     id: 7,
  //     displayName: "Merge Fields",
  //     iconName: this.iconConst.MERGE_FIELDS,
  //     route: "merge-fields",
  //   },
  //    */

  //   // {
  //   //   id: 8,
  //   //   displayName: "Email Template",
  //   //   iconName: this.iconConst.EMAIL_TEMPLATE,
  //   //   route: "email-template",
  //   // },

  //   // {
  //   //   id: 9,
  //   //   displayName: "Create Email",
  //   //   iconName: this.iconConst.EMAIL_TEMPLATE,
  //   //   route: "create-email",
  //   // },

  //   // {
  //   //   id: 10,
  //   //   displayName: "Send Queue Email",
  //   //   iconName: this.iconConst.SEND_EMAIL,
  //   //   route: "send-queue-email",
  //   // },
  //   // {
  //   //   id: 11,
  //   //   displayName: "Marketing",
  //   //   iconName: this.iconConst.MARKETING,
  //   //   route: "marketing",
  //   // },
  //   /*
  //  {
  //    id: 12,
  //    displayName: "Stages",
  //    iconName: this.iconConst.MERGE_FIELDS,
  //    route: "stages",
  //  },
  //  {
  //    id: 13,
  //    displayName: "Product Category",
  //    iconName: this.iconConst.PRODUCT,
  //    route: "product-category",
  //  },
  //  {
  //    id: 14,
  //    displayName: "Products",
  //    iconName: this.iconConst.PRODUCT,
  //    route: "products",
  //  },
  //  {
  //    id: 15,
  //    displayName: "Products Stages",
  //    iconName: this.iconConst.MERGE_FIELDS,
  //    route: "products-stages",
  //  },*/
  //   //{
  //   //   id: 16,
  //   //   displayName: "Change Password",
  //   //   iconName: this.iconConst.PASSWORD,
  //   //   route: "change-password",
  //   // },
  //   // {
  //   //   id: 17,
  //   //   displayName: "Setting",
  //   //   iconName: this.iconConst.SETTING,
  //   //   route: "setting",
  //   // },
  //   // {
  //   //   id: 18,
  //   //   displayName: "User",
  //   //   iconName: this.iconConst.USER,
  //   //   route: "user",
  //   // },
  //   // {
  //   //   id: 19,
  //   //   displayName: "Tags",
  //   //   iconName: this.iconConst.TAGS,
  //   //   route: "tags",
  //   // },
  //   // {
  //   //   id: 20,
  //   //   displayName: "Tickets",
  //   //   iconName: this.iconConst.TICKET,
  //   //   route: "tickets",
  //   // },
  //   // {
  //   //   id: 24,
  //   //   displayName: "Department",
  //   //   iconName: this.iconConst.TICKET,
  //   //   route: "department",
  //   // },
  //   {
  //     id: 25,
  //     displayName: "Organization",
  //     iconName: this.iconConst.TICKET,
  //     route: "admin/organization",
  //   },
  //   {
  //     id: 26,
  //     displayName: "OrganizationUser",
  //     iconName: this.iconConst.TICKET,
  //     route: "client/organizationUser",
  //   },
  //   // {
  //   //   id: 21,
  //   //   displayName: "Access Role ",
  //   //   iconName: this.iconConst.ACCESSROLE,
  //   //   route: "#",
  //   //   sub_menu: [
  //   //     {
  //   //       id: 22,
  //   //       displayName: "Roles",
  //   //       iconName: this.iconConst.TICKET,
  //   //       route: "roles",
  //   //     }, {
  //   //       link_name: "Login Form",
  //   //       link: "/posts/login-form",
  //   //     }, {
  //   //       link_name: "Card Design",
  //   //       link: "/posts/card-design",
  //   //     }
  //   //   ]
  //   // },

  // ];

  navItems1 = [
    {
      id: 1,
      displayName: "Admin Dashboard",
      iconName: this.iconConst.DASHBOARD,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "dashboard2",
    },

    {
      id: 2,
      displayName: "Organization",
      iconName: this.iconConst.COMPANY,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', "SUPER_ADMIN",],
      route: "organization",
    },
    {
      id: 3,
      displayName: "Admin",
      iconName: this.iconConst.USER,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', "SUPER_ADMIN",],
      route: "admin-user",
    },
    {
      id: 4,
      displayName: "Audit Log",
      iconName: this.iconConst.LOG,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "audit-log",
    },
  ];
  navItems2 = [
    {
      id: 10,
      displayName: "Dashboard",
      iconName: this.iconConst.DASHBOARD,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "dashboard",
    },

    {
      id: 11,
      displayName: "Organization User",
      iconName: this.iconConst.USER,
      roles: ["Admin", "Super Admin", 'ADMIN', , "SUPER_ADMIN",],
      route: "organizationUser",
    },
    {
      id: 12,
      displayName: "Customer",
      iconName: "fa fa-building",
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "clientCompany",
    },
    {
      id: 13,
      displayName: "Department",
      iconName: this.iconConst.GROUPS,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "department",
    },
    {
      id: 17,
      displayName: "Tags",
      iconName: this.iconConst.TAGS,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "tags",
    },
    {
      id: 14,
      displayName: "Setting",
      iconName: this.iconConst.SETTING,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "setting",
    },
    {
      id: 15,
      displayName: "Create Email",
      iconName: this.iconConst.SEND_EMAIL,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "create-email",
    },

    {
      id: 16,
      displayName: "Tickets",
      iconName: this.iconConst.TICKET,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "tickets",
    },

    {
      id: 18,
      displayName: "Leads",
      iconName: this.iconConst.LEADS,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "lead",
    },
    {
      id: 19,
      displayName: "Audit Log",
      iconName: this.iconConst.LOG,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "audit-log",
    },
    {
      id: 20,
      displayName: "Email Template",
      iconName: this.iconConst.EMAIL_TEMPLATE,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', 'General "STAFF"', "STAFF", "SUPER_ADMIN",],
      route: "email-template",
    },

  ];
  navItems3 = [
    {
      id: 16,
      displayName: "Tickets",
      iconName: this.iconConst.TICKET,
      roles: ["Admin", "Super Admin", 'ADMIN', 'USER', "SUPER_ADMIN",],
      route: "tickets",
    },
  ];
  type_id: any


  constructor(
    private layoutService: LayoutService,
    private router: Router,
    private loginService: LoginService,
    private localStorageService: LocalStorageService,
    private _GlobalService: GlobalService,
    private cdr: ChangeDetectorRef,
    private navStateService: NavigationStateService // Inject the service
  ) { }

  // ngOnInit() {
  //   setTimeout(() => {
  //     const userInfo = this.localStorageService.getLocalStorageItem("response")
  //     console.log("userInfo", userInfo)
  //     if (userInfo.data.type_id === 1) {
  //       this.navItems = this.navItems1
  //       this.cdr.detectChanges();
  //     } else {
  //       this.navItems = this.navItems2
  //     }
  //     //this.navItems = this.navItems1
  //   }, 3000)

  //   this.getUserInfo();
  //   this.loadAvailableRoutes();
  //   this.getNavMenu();

  // }

  ngOnInit() {
    const userStr = this.localStorageService.getLocalStorageItem("response");
    this.user_type_id = Number(
      userStr.data.type_id
    );

    console.log("type id info:", userStr, this.user_type_id)
    // 1. Subscribe to the BehaviorSubject
    this.navSubscription = this.navStateService.currentNavType.subscribe(
      (type) => {
        // if (type === "CLIENT") {
        //   this.navItems = this.navItems2;
        // } else if (type === "ADMIN") {
        //   this.navItems = this.navItems1;
        // } else {
        //   // Handle initial load logic here if needed,
        //   // otherwise, let the existing setTimeout logic handle the default
        //   this.handleInitialLoad();
        // }
        // this.type_id = type;
        if (type === "2") {
          this.navItems = this.navItems2;
        } else if (type === "1") {
          this.navItems = this.navItems1;
        } else {
          // Handle initial load logic here if needed,
          // otherwise, let the existing setTimeout logic handle the default
          this.handleInitialLoad();
        }

        // Manually trigger change detection if Angular doesn't pick it up immediately
        this.cdr.detectChanges();
      }
    );

    this.getUserInfo();
    // this.getNavMenu(); // You might want to disable this if you are strictly using navItems1/2
  }
  handleInitialLoad() {
    setTimeout(() => {
      const userInfo = this.localStorageService.getLocalStorageItem("response");

      if (userInfo && userInfo.data) {
        if (userInfo.data.type_id === 3) {
          this.navItems = this.navItems3;
        } else if (userInfo.data.type_id === 1) {
          if (this.navItems !== this.navItems2) {
            this.navItems = this.navItems1;
          }
        } else {
          this.navItems = this.navItems2;
        }
      }

      this.cdr.detectChanges();
    }, 1000);
  }

  ngOnDestroy() {
    // Clean up subscription to avoid memory leaks
    if (this.navSubscription) {
      this.navSubscription.unsubscribe();
    }
  }

  // ... rest of your code

  userName: string;
  userInfo: any;


  getUserInfo() {
    // this.imageUrl = this.localStorageService.getLocalStorageItem("image_path");
    // this.userInfo = this.localStorageService.getLocalStorageItem("user_detail");
    this.userName = this.layoutService.getUserFullName();
  }

  toogleSideNav() {
    $("body").toggleClass("sidebar-toggled");
    $(".sidebar").toggleClass("toggled");
  }

  private loadAvailableRoutes() {
    const userRole = this.localStorageService.getLocalStorageItem("user");

    let role = JSON.parse(userRole);
    let role_id = role.role_id;
    this._GlobalService.getRoleListRoutes(role_id).subscribe((res) => {
      this._GlobalService.setPermission(res.data);
    });
  }

  getNavMenu() {
    const payload = {
      page: 1,
      limit: 200,
      fields: [{}],
    };
    this._GlobalService.menuListService(payload).subscribe((res) => {
      console.log("menu res;", res);
      this.navItems = res.data;
      console.log("nav item:", this.navItems);
    });
  }

  navigateToAdmin(): void {
    this.navStateService.updateNav("1");
    const data = { type_id: 1 };
    this.localStorageService.setLocalStorageItem(
      'type_id',
      JSON.stringify(data.type_id)
    );
    this.localStorageService.setLocalStorageItem(
      "organizationInfo",
      ''
    );
    this.router.navigate(["/dashboard2"]);
  }
}
